<template>
  <modal 
    :show.sync="show"
    modal-classes="modal-dialog-centered"
    @close="close">
    <div 
      slot="base-content" 
      class="card card-plain mb-0">
      <div class="modal-header justify-content-center">
        <button 
          type="button" 
          class="btn-sm close text-dark" 
          data-dismiss="modal" 
          aria-hidden="true"
          @click="close">
          <i class="now-ui-icons ui-1_simple-remove"/>
        </button>
        <div class="header header-primary text-center">
          <h4 class="font-weight-bold m-0">Review</h4>
        </div>
      </div>
      <div class="modal-body pt-0">
        <div class="row align-items-center">
          <div class="col-auto">
            <h5 class="card-title">{{ data.reviewerName }}</h5>
          </div>
          <div class="col-auto">
            <star-rating 
              v-model="data.stars"
              :increment="0.1" 
              :show-rating="false"
              :star-size="20"
              :inline="true"
              :read-only="true"/>
          </div>
        </div>
        <p class="mb-2">"{{ data.reviewText }}"</p>
        <div class="text-right">{{ dateFormat(data.reviewDate) }}</div>
      </div>
    </div>
  </modal>
</template>
<script>
	import moment from 'moment';
  import StarRating from 'vue-star-rating';
  import { Modal } from '@/components';

  export default {
    components: {
      Modal,
			StarRating
    },
    props: {
      open: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        show: false
      };
    },
    watch: {
      open() {
        this.show = this.open;
      }
    },
    methods: {
      dateFormat(date) {
        return moment(date).format('MM/DD/YYYY')
      },
      close() {
        this.$emit('close');
      }
    }
  }
</script>
